import * as React from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { PostQuery } from './Shared';

interface QuoteSiteNotesPopupProps {
    showModal: boolean;
    jobQuoteId: number;
    notes: GenericList[];
    hideModal(): void;
    update(notes: GenericList[]): void;
}

interface GenericList {
    id: number;
    name: string;
}

interface QuoteSiteNotesPopup {
    note: string;
}

export default class QuoteSiteNotePopup extends React.Component<QuoteSiteNotesPopupProps, QuoteSiteNotesPopup> {
    constructor(props: any) {
        super(props);

        this.state = {
            note: ""
        };

    }

    handleChange = (e: any) => {
        let notes = e.target.value;

        this.setState({ note: notes });
    }

    hideSiteNotesModal = () => {
        this.props.hideModal();
    }

    addNote = () => {
        this.addSiteNote();
    }

    addSiteNote = async () => {
        let addNote = {
            jobQuoteId: this.props.jobQuoteId,
            note: this.state.note
        }

        var jsonItem = JSON.stringify(addNote);

        const apiUrl = "AddJobQuoteSiteNote";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                //remove note from list
                var notes = this.props.notes;
                notes.push(result.data);

                this.props.update(notes);
                this.setState({ note: "" });

                toast.success("Site Note Added Successfully");
            }
        }   
    }

    deleteNote = (e: any, index: number) => {
        e.preventDefault();

        var noteToDelete = this.props.notes[index];
        if (noteToDelete) {
            this.deleteSiteNote(noteToDelete.id, index);
        }
    }

    async deleteSiteNote(id: number, index: number) {
        let deleteNote = {
            id: id
        }

        var jsonItem = JSON.stringify(deleteNote);

        const apiUrl = "DeleteJobQuoteSiteNote";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                //remove note from list
                var notes = this.props.notes;
                notes.splice(index, 1);

                this.props.update(notes);
                this.setState({ note: "" });

                toast.success("Site Note Removed Successfully");
            }
        }
    }

    render() {
        let contents = this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <Modal show={this.props.showModal} onHide={this.hideSiteNotesModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Site Specific Notes</Modal.Title>
                    <button type="button" className="close" onClick={this.hideSiteNotesModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <div className="marginBottom10">Add any site specific notes that you want to appear on the Quote</div>
                    <label className="input-group input-group__max--width" htmlFor="editNotes">
                        <span className="label-small">Notes</span>
                        <textarea className="input job__noteSize marginRight10" id="note" name="note" value={this.state.note} onChange={(e) => this.handleChange(e)}></textarea>
                        <button type="button" className="popup-button--yes" onClick={this.addNote}>Add</button>
                    </label>

                    <div className={this.props.notes.length === 0 ? "hidden" : "overflowAuto"}>
                        <table className="table table__small tableColours marginTop10">
                            <thead>
                                <tr>
                                    <th>Note</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            {this.props.notes.map((note, index) =>
                                <tbody key={note.id}>
                                    <tr>
                                        <td>{note.name}</td>
                                        <td>
                                            <a className="makeitred" href="#" onClick={(e) => this.deleteNote(e, index)}>
                                                <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button className="popup-button--yes" onClick={this.hideSiteNotesModal}>Close</button>
                </Modal.Footer>
            </Modal>

        )
    }

}